import { Moment } from "moment";

export interface T_DEVICE {
  uid: number;
  name: string;
  watt: number;
  hashrate: number;
  price: number;
  link: string;

  //
  // hash_price: number;
  // price_watt: number;
  // hash_watt: number;
  // hash_watt_price: number;
  rank: number;
  rank_point?: number;
  temp?: string;
}

export interface T_SHOP_PRICE {
  uid: number;
  owner: string;
  link: string;
  price: number;
  verified: boolean;
  date_add: Moment;
}

// 접속 주소 분기
export function get_url_head() {
  // console.log("NODE_ENV", process.env.NODE_ENV);
  if (process.env.NODE_ENV == "development") {
    // return "http://localhost:4000";
  }
  return "https://gvm.sidnft.com:3443";
}
